/* eslint semi:0 */
export const fantasyConfig = {
  whiteListCountryCodes: ['gb', ],
  pageTypes: ['post', ],
  locales: ['en', ],
  isEmbedded: false,
  daysWhiteList: [1, 5, ],
  isTopX: false,
  isSlideshow: false,
  featureId: 'Fantasy',
  blacklistedCategories: ['sponsored', ],
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/fantasyMounterConfig.js